/* unplugin-vue-components disabled */import script from "./SharePopup.vue?vue&type=script&setup=true&lang=js"
export * from "./SharePopup.vue?vue&type=script&setup=true&lang=js"

import "./SharePopup.vue?vue&type=style&index=0&id=675c5752&lang=scss"

const __exports__ = script;

export default __exports__